export default __webpack_public_path__ + "static/tree-cameraRaw-tyrkys-h348-028a42841e25418113322fd8f1f6a408.png";